// extracted by mini-css-extract-plugin
export default {"team":"Team_team__5xY1Y"};